'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdCameraEnhance = function MdCameraEnhance(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm20 28.4l-2.1-4.6-4.5-2.2 4.5-2 2.1-4.6 2.1 4.6 4.5 2-4.5 2.2z m0 1.6c4.6 0 8.4-3.7 8.4-8.4s-3.8-8.2-8.4-8.2-8.4 3.6-8.4 8.2 3.8 8.4 8.4 8.4z m-5-25h10l3 3.4h5.4c1.8 0 3.2 1.4 3.2 3.2v20c0 1.8-1.4 3.4-3.2 3.4h-26.8c-1.8 0-3.2-1.6-3.2-3.4v-20c0-1.8 1.4-3.2 3.2-3.2h5.4z' })
        )
    );
};

exports.default = MdCameraEnhance;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/camera-enhance.js
// module id = 2670
// module chunks = 0